import StoreIntegrationCheckWarning from './StoreIntegrationCheckWarning'

export default StoreIntegrationCheckWarning
